import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import CheckSvg from 'images/v5/icons/check.svg';
import Button from 'layout/atoms/Button/Button';
import Label from 'layout/atoms/Label';
import Modal from 'layout/atoms/Modal/Modal';
import { closeModal, selectModalByName } from 'store/layoutSlice';
import { selectComponentsCostsStatus, updateProductVariant, updateStoreProductPrice, } from 'store/specificationComponentsCostsSlice';
import { fetchSpecificationProblems } from 'store/specificationDetailsSlice';
const MODAL_NAME = 'componentCostsPriceDiff';
function ComponentCostsPriceDiff() {
    const { t } = useTranslation(['specification', 'common']);
    const dispatch = useDispatch();
    const loading = useSelector(selectComponentsCostsStatus).updateProductVariant;
    const modal = useSelector(selectModalByName(MODAL_NAME));
    const data = modal === null || modal === void 0 ? void 0 : modal.data;
    return (React.createElement(Modal, { name: MODAL_NAME, size: "s", header: React.createElement(Label, { weight: "strong" }, t('variant_price_different_in_library')), footer: React.createElement(React.Fragment, null,
            React.createElement(Button, { theme: "ghost", onClick: () => dispatch(closeModal({ name: MODAL_NAME })) }, t('cancel')),
            React.createElement(Button, { color: "primary", leftIcon: React.createElement(CheckSvg, null), onClick: () => {
                    dispatch(updateProductVariant({
                        productVariantId: data.productVariantId,
                        price: data.price,
                        currencyId: data.currencyId,
                    })).then(() => {
                        dispatch(closeModal({ name: MODAL_NAME }));
                        dispatch(updateStoreProductPrice({
                            price: data.price,
                            currencyId: data.currencyId,
                            productVariantSnapshotId: data.variantId,
                        }));
                        dispatch(fetchSpecificationProblems());
                    });
                }, loading: loading === 'loading' }, t('set_as_current_price'))) }, t('update_variant_price_question')));
}
export default memo(ComponentCostsPriceDiff);
